/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { features, language } from "config";
import { FirebaseContext } from "common";
import Material_React_Table from "../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
import AlertDialog from "../components/AlertDialog";
export default function Notifications() {
  const { api } = useContext(FirebaseContext);
  const { sendNotification, editNotifications } = api;

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const columns = [
    {
      header: language.device_type,
      accessorKey: "devicetype",
      // lookup: { All: "All", ANDROID: "Android", IOS: "iOS" },
    },
    {
      header: language.user_type,
      accessorKey: "userType",
      // lookup: { patient: language.patient, doctor: language.doctor },
    },
    { header: language.title,
      accessorKey: "title" },
    { header: language.body, 
      accessorKey: "body" },
  ];

 const onRowAdd =(newData) =>{
    new Promise((resolve) => {
      setTimeout(() => {
        resolve();
        const tblData = data;
        tblData.push(newData);
        features.AllowCriticalEditsAdmin
          ? dispatch(sendNotification(newData))
          : alert(language.demo_mode);
        dispatch(editNotifications(newData, "Add"));
      }, 600);
    })
  };

  const onRowUpdate =(newData, oldData) =>{
    new Promise((resolve) => {
      setTimeout(() => {
        resolve();
        dispatch(editNotifications(newData, "Update"));
      }, 600);
    })
  };

  const onRowDelete=(oldData) =>{
    new Promise((resolve) => {
      setTimeout(() => {
        resolve();
        dispatch(editNotifications(oldData, "Delete"));
      }, 600);
    })
  };

  const [data, setData] = useState([]);
  const notificationdata = useSelector((state) => state.notificationdata);
  const dispatch = useDispatch();

  useEffect(() => {
    if (notificationdata.notifications) {
      setData(notificationdata.notifications);
    } else {
      setData([]);
    }
  }, [notificationdata.notifications]);

  return notificationdata.loading ? (
    <CircularLoading />
  ) : (
    <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { id: false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>

  );
}



  // const columns = [
  //   // {
  //   //   title: language.drug_exposure_id,
  //   //   field: "drug_exposure_id",
  //   //   initialEditValue: "",
  //   // },
  //   {
  //     Header: language.personid,
  //     accessorKey: "person_id",

  //   },
  //   {
  //     Header: language.drug_concept_id,
  //     accessorKey: "drug_concept_id",


  //     // filterComponent: ({ columnDef, onFilterChanged }) => <UsersCombo />,
  //   },
  //   {
  //     Header: language.startdate,
  //     accessorKey: "drug_exposure_start_date",
     
  //   },
  //   {
  //     Header: language.start_datetime,
  //     accessorKey: "drug_exposure_start_datetime",
     
  //   },
  //   // {
  //   //   title: language.enddate,
  //   //   field: "drug_exposure_end_date",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.end_datetime,
  //   //   field: "drug_exposure_end_datetime",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.verbatim_end_date,
  //   //   field: "verbatim_end_date",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.drug_type_concept_id,
  //   //   field: "drug_type_concept_id",
  //   //   lookup: otcT,
  //   // },
  //   // {
  //   //   title: language.stop_reason,
  //   //   field: "stop_reason",
  //   //   initialEditValue: "",
  //   // },
  //   // { title: language.refills, field: "refills", initialEditValue: "" },
  //   // { title: language.quantity, field: "quantity", initialEditValue: "" },
  //   // {
  //   //   title: language.days_supply,
  //   //   field: "days_supply",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.sig,
  //   //   field: "sig",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.route_concept_id,
  //   //   field: "route_concept_id",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.lot_number,
  //   //   field: "lot_number",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.provider_id,
  //   //   field: "provider_id",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.visit_occurrence_id,
  //   //   field: "visit_occurrence_id",
  //   //   initialEditValue: "",
  //   // },
  //   // {
  //   //   title: language.visit_detail_id,
  //   //   field: "visit_detail_id",
  //   //   initialEditValue: "",
  //   // },
  //   {
  //     Header: language.drug_source_value,
  //     accessorKey: "drug_source_value",
     
  //   },
  //   {
  //     Header: language.drug_source_concept_id,
  //     accessorKey: "drug_source_concept_id",
     
  //   },
  //   {
  //     Header: language.route_source_value,
  //     accessorKey: "route_source_value",
    
  //   },
  //   {
  //     Header: language.dose_unit_source_value,
  //     accessorKey: "dose_unit_source_value",
  
  //   },
  // ];